module.exports = __webpack_public_path__ + "img/logo.aea2b954.png";